// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#00838f","secundaryColor":"#006064","accentColor":"#006064"};